<script lang="ts">
    import {fade} from 'svelte/transition';
    import LicenseApi from "../service/license-api";

    export let activations: ActivationsJson = [];

    let deactivating: boolean = false;
    let checkBoxThreshold: number = 5;
    let allSelected: boolean = false;

    $: selectedActivations = activations.filter(a => a.checked);

    const toggleAll = () => {

        setTimeout(() => {
            activations = activations.map((d) => {
                d.checked = allSelected;
                return d;
            });
        }, 0)
    }

    const deleteSelected = async () => {
        let confirmDelete = confirm('Are you sure you want to deactivate the selected sites?');
        if (!confirmDelete) {
            return;
        }

        deactivating = true;
        const api = new LicenseApi();

        selectedActivations.forEach((activation) => {
            api.deactivateUrl(activation.key, activation.url).then(() => deleteActivation(activation));
        });
    }

    const deleteActivation = (activation: Activation) => {
        activations = activations.filter(a => {
            return a.url !== activation.url;
        });
    }

    const deactivate = (activation: Activation) => {
        new LicenseApi().deactivateUrl(activation.key, activation.url).then(() => {
            deleteActivation(activation)
        });
    }

</script>
<div>
	{#if selectedActivations.length > 1 }
		<button on:click={deleteSelected} class="mb-4 bg-lightest border-solid-blue-dark text-xs py-1 px-4 color-blue-dark rounded-sm">
			{#if deactivating }
				<span class="icon-spinner -animated"></span>
			{:else }
				Deactivate Selected ({selectedActivations.length})
			{/if}
		</button>
	{/if}
	<table class="subscription-options -activations">
		<tbody>
		<tr>
			{#if activations.length > checkBoxThreshold}
				<th class="-check">
					<input type="checkbox" on:change={toggleAll} bind:checked={allSelected}>
				</th>
			{/if}
			<th>
				Site
				<small>({activations.length})</small>
			</th>
			<th class="-version">Version</th>
			<th class="-date">Activation Date</th>
			<th>&nbsp;</th>
		</tr>
		{#each activations as activation (activation.url)}
			<tr class="activation" class:row-selected={activation.checked} out:fade>
				{#if activations.length > checkBoxThreshold}
					<td>
						<input type="checkbox" bind:checked={activation.checked}>
					</td>
				{/if}
				<td class="-site">
					<a href={activation.url} target="_blank">{activation.url.replace( '//', '' )}</a>
				</td>
				<td class="-version">
					{#if activation.version }
						{activation.version}
					{:else}
						-
					{/if}
				</td>
				<td class="-date">
					{activation.date}
				</td>
				<td class="-action">
					<span role="none" on:click={() => deactivate( activation ) } class="color-blue-dark hover:color-blue-darker cursor-pointer">deactivate</span>
				</td>
			</tr>
		{/each}


		</tbody>
	</table>
</div>